var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOrders = function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 80,
    rx: 8,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m40.649 17.286-7.723 1.505a4 4 0 0 0-3.161 4.691l1.53 7.852c1.734-.337 3.398.707 3.714 2.333.317 1.626-.832 3.219-2.567 3.557l5.355 27.483a4 4 0 0 0 4.69 3.161l23.558-4.59a4 4 0 0 0 3.161-4.69l-5.354-27.484c-1.735.338-3.398-.706-3.715-2.332-.317-1.627.832-3.22 2.567-3.557l-1.53-7.852a4 4 0 0 0-4.69-3.162l-7.723 1.505c-.135 1.784-1.531 3.355-3.483 3.735-1.951.38-3.835-.552-4.63-2.155Z",
    fill: "url(#orders_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F7F7F7",
    strokeWidth: 4,
    strokeDasharray: "3 3",
    d: "m35.832 33.801 22.054-4.756"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m61.984 14.079-7.697-1.633a4 4 0 0 0-4.742 3.083l-1.66 7.826c1.729.367 2.851 1.978 2.508 3.599-.344 1.62-2.025 2.637-3.753 2.27l-5.81 27.391a4 4 0 0 0 3.083 4.743l23.478 4.98a4 4 0 0 0 4.743-3.083l5.81-27.39c-1.73-.367-2.853-1.979-2.509-3.6.344-1.62 2.024-2.637 3.753-2.27l1.66-7.826a4 4 0 0 0-3.083-4.743l-7.696-1.632c-.822 1.59-2.72 2.49-4.665 2.077-1.945-.412-3.315-2.006-3.42-3.792Z",
    fill: "url(#orders_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m62.051 14.508-7.773-1.649a4 4 0 0 0-4.725 3.006l-1.624 6.973a4.003 4.003 0 0 0-.105.922c.043.007.085.015.128.024 1.729.367 2.852 1.978 2.508 3.6a2.694 2.694 0 0 1-.026.111c.095.036.193.068.292.096l3.34.954 11.001 2.5 9.674 1.792c.243.045.486.067.725.067.01-.07.022-.14.037-.21.338-1.595 1.973-2.606 3.674-2.286a4.03 4.03 0 0 0 .204-.668l1.526-7.137a4 4 0 0 0-3.081-4.75l-7.69-1.63c-.821 1.59-2.72 2.49-4.665 2.077-1.945-.412-3.314-2.006-3.42-3.792Z",
    fill: "#5298F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F7F7F7",
    strokeWidth: 4,
    strokeDasharray: "3 3",
    d: "m51.755 27.05 22 5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 110,
    height: 80,
    rx: 8,
    fill: "#F7F7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m40.649 18.286-7.723 1.505a4 4 0 0 0-3.161 4.691l1.53 7.852c1.734-.338 3.398.707 3.714 2.333.317 1.626-.832 3.219-2.567 3.557l5.355 27.483a4 4 0 0 0 4.69 3.161l23.558-4.59a4 4 0 0 0 3.161-4.69l-5.354-27.484c-1.735.338-3.398-.706-3.715-2.332-.317-1.627.832-3.22 2.567-3.557l-1.53-7.852a4 4 0 0 0-4.69-3.162l-7.723 1.505c-.135 1.784-1.531 3.355-3.483 3.735-1.951.38-3.835-.552-4.63-2.155Z",
    fill: "url(#orders_svg__c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m40.623 17.887-7.697 1.5a4 4 0 0 0-3.156 4.716l1.429 7.087c.05.251.123.491.216.72 1.681-.254 3.26.777 3.569 2.358.008.044.016.087.022.131.273.008.55-.013.83-.064l12.639-2.298 7-1.5 4.252-1.063a4.03 4.03 0 0 0 .381-.115c-.307-1.622.84-3.206 2.57-3.543l.074-.014a4.002 4.002 0 0 0-.083-1.042l-1.466-6.879a4 4 0 0 0-4.677-3.092l-7.791 1.518c-.135 1.784-1.531 3.354-3.482 3.735-1.952.38-3.835-.552-4.63-2.155Z",
    fill: "#384952"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 4,
    strokeDasharray: "3 3",
    d: "m35.832 34.801 22.054-4.756"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m61.984 15.079-7.697-1.633a4 4 0 0 0-4.742 3.083l-1.66 7.826c1.729.367 2.851 1.978 2.508 3.599-.344 1.62-2.025 2.637-3.753 2.27l-5.81 27.391a4 4 0 0 0 3.083 4.743l23.478 4.98a4 4 0 0 0 4.743-3.083l5.81-27.39c-1.73-.367-2.853-1.979-2.509-3.6.344-1.62 2.024-2.637 3.753-2.27l1.66-7.826a4 4 0 0 0-3.083-4.743l-7.696-1.632c-.822 1.59-2.72 2.49-4.665 2.077-1.945-.412-3.315-2.006-3.42-3.792Z",
    fill: "url(#orders_svg__d)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m62.051 15.508-7.773-1.649a4 4 0 0 0-4.725 3.006l-1.624 6.973a4.003 4.003 0 0 0-.105.922c.043.007.085.015.128.024 1.729.367 2.852 1.978 2.508 3.6a2.737 2.737 0 0 1-.026.111c.095.036.193.068.292.096l3.34.954 11.001 2.5 9.674 1.792c.243.045.486.067.725.068.01-.07.022-.14.037-.21.338-1.596 1.973-2.607 3.674-2.287.086-.212.154-.436.204-.668l1.526-7.137a4 4 0 0 0-3.081-4.75l-7.69-1.63c-.821 1.59-2.72 2.49-4.665 2.077-1.945-.412-3.314-2.006-3.42-3.792Z",
    fill: "#5298F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 4,
    strokeDasharray: "3.2 3.2",
    d: "m51.755 28.05 22 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "orders_svg__a",
    x1: 44.705,
    y1: 16.496,
    x2: 44.705,
    y2: 72.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "orders_svg__b",
    x1: 56.312,
    y1: 4,
    x2: 56.312,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#6D7A80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "orders_svg__c",
    x1: 44.705,
    y1: -104,
    x2: 44.705,
    y2: 73.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "orders_svg__d",
    x1: 56.312,
    y1: 23,
    x2: 56.312,
    y2: 124.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#6D7A80"
  })))));
};

export default SvgOrders;